// Format a calendar date ('YYYY-MM-DD') exactly as stored — no time-zone shift.
export const fmtDay = (ymd, opts = { day: 'numeric', month: 'long', year: 'numeric' }) => {
  if (!ymd) return '—';
  const [y, m, d] = String(ymd).slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, opts);
};
